import { render, staticRenderFns } from "./productionManager.vue?vue&type=template&id=513403ca&scoped=true&"
import script from "./productionManager.vue?vue&type=script&lang=js&"
export * from "./productionManager.vue?vue&type=script&lang=js&"
import style0 from "./productionManager.vue?vue&type=style&index=0&id=513403ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513403ca",
  null
  
)

export default component.exports